import { render, staticRenderFns } from "./IdCardNumber.vue?vue&type=template&id=d4fe99ea&"
import script from "./IdCardNumber.vue?vue&type=script&lang=js&"
export * from "./IdCardNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports